import React from 'react';

const BaseLeftSection = ({
  title,
  content,
  contentSrc,
  contentSrcSet,
}) => {
  return (
    <div className="top-left-text-container">
      <div className='top-left-text tag-menu-1'>{title}</div>
      <div className='top-left-text-with-image-container'>
        {
          contentSrc && (
            <img
              alt=""
              className='toop-left-text-image'
              src={contentSrc}
              srcSet={contentSrcSet}
            />
          )
        }
        <div className='top-left-text subheading'>{content}</div>
      </div>
    </div>
  )
}

export default BaseLeftSection;
